import { Input, Select, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import FormWrapper from './FormWrapper';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRolePrivileges } from '../../../store/slices/role-privilege-slice';
import { fetchUsers } from '../../../store/slices/user-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const RolePrivilegeForm = () => {
    const [userId, setUserId] = useState('');
    const [access, setAccess] = useState('');

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: rolePrivileges } = useSelector((state) => state.rolePrivilege);
    const { data: users } = useSelector((state) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchRolePrivileges());
        dispatch(fetchUsers());
    }, []);

    useEffect(() => {
        if(MODE === 'EDIT' && rolePrivileges.length) {
            const ID = searchParams.get('id');
            const selectedRolePrivileges = rolePrivileges.filter((item) => item.role_privilege_id === ID);
            setUserId(selectedRolePrivileges[0].user_id);
            setAccess(selectedRolePrivileges[0].access);
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, rolePrivileges]);

    const userList = users.map((user) => (
        { value: user.user_id, label: user.user_name }
    ));

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'user_id': userId,
            'access': access,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.role_privilege_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/role-privilege/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/role-privilege-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }  
    }
    const resetHandler = () => {
        setUserId('');
        setAccess('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Role Privilege</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>User:</label>
                    <Select
                        placeholder="Select User"
                        style={{ width: '100%' }}
                        size='large'
                        onChange={(value) => setUserId(value)}
                        options={userList}
                        allowClear
                        { ...(userId && { value: userId }) }
                    />
                </div>
                <div className='control'>
                    <label>Access:</label>
                    <Input 
                        onChange={(e) => setAccess(e.target.value)} 
                        value={access}
                        size='large'
                        placeholder='Access' 
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default RolePrivilegeForm;


